import React, { useEffect, useState } from 'react';

const CustomCursor: React.FC = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      setPosition({ x: e.clientX, y: e.clientY });
      setIsVisible(true);
    };

    const handleMouseLeave = () => setIsVisible(false);
    const handleMouseEnter = () => setIsVisible(true);

    // Event delegation so hover state also applies to elements rendered
    // after this component mounts (e.g. the AI assistant UI).
    const handleMouseOver = (e: MouseEvent) => {
      const target = e.target as HTMLElement | null;
      setIsHovering(
        !!target?.closest(
          'a, button, [role="button"], input, textarea, select, .hover-target',
        ),
      );
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseover', handleMouseOver);
    document.addEventListener('mouseleave', handleMouseLeave);
    document.addEventListener('mouseenter', handleMouseEnter);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseover', handleMouseOver);
      document.removeEventListener('mouseleave', handleMouseLeave);
      document.removeEventListener('mouseenter', handleMouseEnter);
    };
  }, []);

  return (
    <>
      <div
        className="fixed pointer-events-none z-[9999] transition-transform duration-100"
        style={{
          left: position.x - 12,
          top: position.y - 12,
          opacity: isVisible ? 1 : 0,
        }}
      >
        <div
          className={`w-6 h-6 rounded-full border-2 border-primary transition-all duration-300 ${
            isHovering ? 'w-16 h-16 bg-primary/20 border-primary/50' : ''
          }`}
        />
      </div>
      <div
        className="fixed pointer-events-none z-[9999] transition-transform duration-150"
        style={{
          left: position.x - 2,
          top: position.y - 2,
          opacity: isVisible ? 1 : 0,
        }}
      >
        <div
          className={`w-1 h-1 rounded-full bg-primary transition-all duration-300 ${
            isHovering ? 'w-2 h-2' : ''
          }`}
        />
      </div>
    </>
  );
};

export default CustomCursor;